import { http } from 'utils'

// Location mutation imports.
import { SET_REGIONS } from 'vx/mutations'

// Location state.
const state = {
  regions: []
}

// Location state getters.
const getters = {}

// Location actions.
const actions = {
  /**
   * Get all locations.
   *
   * @return Promise
   */
  getRegions ({ commit }, params = {}) {
    return http.get('regions', { params })
      .then((response) => {
        commit(SET_REGIONS, response.data)

        return response
      })
  }
}

// Location state mutations.
const mutations = {
  [SET_REGIONS] (state, regions) {
    state.regions = regions
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
